import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./Footer.css";
import AdmissionDropdown from "./AdmissionDropdown";
import { campuses, telHref } from "../data/campusesData";

const headOffice = campuses[0].contacts[0];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* About Section */}
            <div className="footer-section">
              <div className="footer-logo">
                <h2>Sri Vani</h2>
                <p>Education Since 1966</p>
              </div>
              <p className="footer-about">
                Excellence in education for over 60 years. We nurture young
                minds with world-class facilities, experienced faculty, and a
                commitment to holistic development.
              </p>
              <div className="footer-social">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <FaTwitter />
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <FaYoutube />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/academics">Academics</Link>
                </li>
                <li>
                  <Link to="/campuses">Our Campuses</Link>
                </li>
                <li>
                  <Link to="/admissions">Admissions</Link>
                </li>
                <li>
                  <Link to="/student-life">Student Life</Link>
                </li>
                <li>
                  <Link to="/gallery">Gallery</Link>
                </li>
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
                <li>
                  <Link to="/news-events">News & Events | Srivani</Link>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
              </ul>
            </div>

            {/* Academics */}
            <div className="footer-section">
              <h3>Academics</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/academics#state-syllabus">State Syllabus</Link>
                </li>
                <li>
                  <Link to="/academics#cbse">CBSE</Link>
                </li>
                <li>
                  <Link to="/academics#icse">ICSE</Link>
                </li>
                <li>
                  <Link to="/academics#cambridge">Cambridge International</Link>
                </li>
                <li>
                  <Link to="/academics#pu-college">PU College</Link>
                </li>
                <li>
                  <Link to="/academics#curriculum-overview">
                    Curriculum Overview
                  </Link>
                </li>
                <li>
                  <Link to="/academics#teaching-methodology">
                    Teaching Methodology
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-section">
              <h3>Contact Us</h3>
              <div className="footer-contact">
                <div className="contact-item">
                  <FaMapMarkerAlt className="contact-icon" />
                  <div>
                    <p>
                      <strong>{campuses[0].locationLabel}</strong>
                    </p>
                    <p>{headOffice.name}</p>
                    <p>
                      {headOffice.addressLines.map((line, i) => (
                        <React.Fragment key={i}>
                          {i > 0 && <br />}
                          {line}
                        </React.Fragment>
                      ))}
                    </p>
                  </div>
                </div>
                <div className="contact-item">
                  <FaPhone className="contact-icon" />
                  <div>
                    {headOffice.phones.map((phone) => (
                      <div key={phone}>
                        <a href={telHref(phone)}>{phone}</a>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="contact-item">
                  <FaEnvelope className="contact-icon" />
                  <div>
                    {headOffice.emails.map((email) => (
                      <div key={email}>
                        <a href={`mailto:${email}`}>{email}</a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* <Link to="/admissions" className="footer-cta-btn">
                Apply for Admission
              </Link> */}
              <AdmissionDropdown label="Apply for Admission" className="footer-cta-btn" />
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Sri Vani Education. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span className="separator">|</span>
              <Link to="/terms">Terms & Conditions</Link>
              <span className="separator">|</span>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
